<template>
  <div class="container">
    <HeadingOne class="-margin-md">収入証明書のご提出</HeadingOne>

    <WizardGroup class="_mb-sm-35 _mb-md-50">
      <MainWizard :active-index="3" type="income"></MainWizard>
    </WizardGroup>

    <template v-if="isNeedIdentify">
      <StepPage class="-success">
        <StepHeader>
          <img
            src="@/assets/images/icons/check-ok.svg"
            class="_i-w-sm-37 _i-w-md-74 _mb-sm-15 _mb-md-30"
            alt=""
          />
          <h2 class="heading">収入証明書のアップロードが完了しました。</h2>
          <p class="_mb-0">
            続いて、ご本人さま確認書類のご提出のお手続きをお願いします。<br />「次へ」を押してください。
          </p>
        </StepHeader>
      </StepPage>
      <BtngroupSingle class="-margin-lg">
        <BtnMain class="-normal" router-name="en026"> 次へ </BtnMain>
      </BtngroupSingle>
    </template>

    <template v-else>
      <StepPage class="-success">
        <StepHeader>
          <img
            src="@/assets/images/icons/check-ok.svg"
            class="_i-w-sm-37 _i-w-md-74 _mb-sm-15 _mb-md-30"
            alt=""
          />
          <h2 class="heading">
            収入証明書のアップロードが完了しました。<br />ありがとうございました。
          </h2>
          <p class="_mb-0">
            審査が完了次第、ご登録いただいたメールアドレスにご案内をお送りいたします。
          </p>
        </StepHeader>
      </StepPage>
      <BtngroupSingle class="-margin-lg">
        <BtnMain class="-normal -md" router-name="sv001">
          au PAY スマートローントップへ
        </BtnMain>
      </BtngroupSingle>
    </template>
  </div>
  <!-- container -->
</template>

<script>
import { getUserDataLambdaInvoke } from "@/utils/LambdaHelper";
import { PERSONAL_CONFIRM_IMAGE_AT } from "@/constants/constant";
import { setMeta } from "@/utils/Meta";
import { goToErrorPage } from "@/utils/Other";
import HeadingOne from "@/components/heading/HeadingOne";
import MainWizard from "@/components/wizard/MainWizard";
import WizardGroup from "@/components/wizard/WizardGroup";
import BtnMain from "@/components/button/BtnMain";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import StepPage from "@/components/steps/StepPage";
import StepHeader from "@/components/steps/StepHeader";

export default {
  name: "Tem022",
  components: {
    StepHeader,
    StepPage,
    BtnMain,
    BtngroupSingle,
    WizardGroup,
    MainWizard,
    HeadingOne,
  },
  setup() {
    setMeta({
      title: "収入証明書のご提出",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,入会,書類提出,収入証明",
    });
  },
  data() {
    return {
      userData: {
        identification_document: "",
        revenue_certificate: "",
      },
    };
  },
  computed: {
    isNeedIdentify() {
      return (
        this.userData.identification_document === "02" &&
        !window.$cookies.get(PERSONAL_CONFIRM_IMAGE_AT)
      );
    },
  },
  mounted() {
    try {
      getUserDataLambdaInvoke()
        .then((res) => {
          for (let key in res) {
            if (Object.hasOwnProperty.call(this.userData, key)) {
              this.userData[key] = res[key].toString().trim();
            }
          }
        })
        .catch((error) => {
          goToErrorPage(error);
        });
    } catch (e) {
      goToErrorPage(e);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.steps-box {
  padding: 20px;
  @include mq-down(md) {
    margin-right: -20px;
    margin-left: -20px;
  }
  @include mq-up(md) {
    border-radius: 10px;
  }
  &.-success {
    background-color: $success;
  }
  > .steps-header {
    text-align: center;
    padding: 30px 0px 30px;
    @include mq-up(md) {
      padding: 40px 20px 60px;
    }
    .heading {
      color: $primary;
      font-weight: bold;
      font-size: 20px;
      @include mq-up(md) {
        font-size: 32px;
      }
    }
  }
  > .steps-body {
    background-color: $white;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 2px 2px rgba($secondary, 0.6);
    @include mq-up(md) {
      border-radius: 10px;
      padding: 40px;
    }
  }
}
</style>
